// test1183
(1183 && 0);
